import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'transformShortenSerialNumber'
})
export class TransformShortenSerialNumberPipe implements PipeTransform {

  transform(value: string): string {
    if(value && value.length>13){
      value = value.substr(0,4)+'...'+value.slice(-5);
    }
    return value;
  }

}
